import React, { useCallback } from 'react';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import { REMOTE_STOP_TRANSACTION } from 'actions/chargerOcpp';
import { useTranslation } from 'react-i18next';
import { GET_STATION_CHARGER_OPERATIONS, MANAGE_STATION_CHARGER_OPERATIONS } from 'components/common/constant';

const RemoteStopTransactionForm = () => {
  const { chargerId } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);

  const getRemoteStopTransaction = useCallback((data, resetForm) => {
    dispatch({
      type: REMOTE_STOP_TRANSACTION.REQUEST,
      payload: { data },
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            toast.success('Remote stop transaction successfully');
            resetForm();
          }
        }
      },
    });
  }, []);

  const getStationChargerOperations =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_STATION_CHARGER_OPERATIONS),
      (data) => data.name
    );

  const manageStationChargerOperations =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_STATION_CHARGER_OPERATIONS),
      (data) => data.name
    );

  const RemoteStopTransactionSchema = Yup.object().shape({
    transactionId: Yup.number().required(t('remoteStopTransaction.transactionId')),
  });

  const initialValues = {
    transactionId: '',
  };

  return (
    <React.Fragment>
      <div className="serverOperation-title-name">{t('remoteStopTransaction.formTitle')}</div>
      <div className="serverOperation-content-wrapper">
        <Card className="serverOperation-form-main">
          <div className="serverOperation-form__block">
            <Formik
              initialValues={initialValues}
              validationSchema={RemoteStopTransactionSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                const formData = {
                  ...values,
                  id: chargerId,
                };
                getRemoteStopTransaction(formData, resetForm);
                setSubmitting(false);
              }}
            >
              {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="serverOperation-form__inner">
                    <Row>
                      <Col>
                        <TextInput
                          isRequired
                          label={t('remoteStopTransaction.transactionLabel')}
                          placeholder={t('remoteStopTransaction.transactionLabel')}
                          type="number"
                          value={values.transactionId}
                          name="transactionId"
                          onChange={handleChange}
                          error={errors.transactionId && touched.transactionId ? errors.transactionId : null}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="serverOperation-save--btn--block">
                    {!_.isEmpty(manageStationChargerOperations) ||
                    (!_.isEmpty(getStationChargerOperations) && !_.isEmpty(manageStationChargerOperations)) ? (
                      <Button type="submit" className="serverOperation-save-btn save--btn" disabled={isSubmitting}>
                        {t('remoteStopTransaction.button')}
                      </Button>
                    ) : (
                      <Button className="serverOperation-save-btn save--btn">{t('remoteStopTransaction.button')}</Button>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
export default RemoteStopTransactionForm;
